import { ClipLoader } from 'react-spinners';

function PlayerLoad() {
  return (
    <div className={'w-full h-full flex-center'} style={{ height: 'calc(100vh - 140px)' }}>
      <ClipLoader />
    </div>
  );
}

export default PlayerLoad;
